module.exports = __webpack_public_path__ + "img/main-fantasy-header.c3661eaa.png";